import * as z from "zod/v4";
import {
  createOrderEditInputSchema,
  createOrderEditOutputSchema,
} from "./base";

/**
 * Schema for updating order discount code
 */

// Data schema for discount code update
const UpdateDiscountCodeData_ = z.object({
  discountCode: z.string().describe("The discount code to apply to the order"),
});

export const UpdateDiscountCodeDataSchema: z.ZodType<UpdateDiscountCodeData> =
  UpdateDiscountCodeData_;
export interface UpdateDiscountCodeData
  extends z.infer<typeof UpdateDiscountCodeData_> {}

// Full input schema
const UpdateDiscountCodeInput_ = createOrderEditInputSchema(
  UpdateDiscountCodeDataSchema,
);

export const UpdateDiscountCodeInput: z.ZodType<UpdateDiscountCodeInput> =
  UpdateDiscountCodeInput_;
export interface UpdateDiscountCodeInput
  extends z.infer<typeof UpdateDiscountCodeInput_> {}

// Output data schema
const UpdateDiscountCodeOutputData_ = z.string();

export const UpdateDiscountCodeOutputDataSchema: z.ZodType<UpdateDiscountCodeOutputData> =
  UpdateDiscountCodeOutputData_;
export type UpdateDiscountCodeOutputData = z.infer<
  typeof UpdateDiscountCodeOutputData_
>;

// Full output schema
const UpdateDiscountCodeOutput_ = createOrderEditOutputSchema(
  UpdateDiscountCodeOutputDataSchema,
);

export const UpdateDiscountCodeOutput: z.ZodType<UpdateDiscountCodeOutput> =
  UpdateDiscountCodeOutput_;
export interface UpdateDiscountCodeOutput
  extends z.infer<typeof UpdateDiscountCodeOutput_> {}
